import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(() => ({
  headerStyling: {
    margin: "10px"
  }
}));
